'use client';

import { reloadOnChunkLoadError } from '@/utils/chunkReload.util';
import { useEffect } from 'react';

// Catches errors thrown from the root layout, which app/error.tsx cannot.
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error.digest);
    reloadOnChunkLoadError(error);
  }, [error]);

  return (
    <html lang='en'>
      <body
        style={{
          display: 'flex',
          minHeight: '100vh',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1rem',
          padding: '1rem',
          fontFamily: 'system-ui, sans-serif',
          textAlign: 'center',
        }}
      >
        <h1>Something went wrong</h1>
        <p>We&apos;re refreshing the page. If this persists, please try again shortly.</p>
        {/* Plain anchor on purpose: the router may be what broke, so force a full page load */}
        {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
        <a href='/'>Back to homepage</a>
      </body>
    </html>
  );
}
